// @flow

import { BASE_URL } from 'app/settings-v2/utils/constants';

const routes = {
  [BASE_URL]: {
    fetch: () =>
      import(
        /* webpackChunkName: 'settings-v2-route' */ 'app/settings-v2/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
